import { axios, createFormData, handleError } from '../axios';

export const adminGetMemberComment = (data) => {
  return new Promise((resolve, reject) => {
    axios
      .post('admin/member/comment', createFormData(data))
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
